// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"37":"d2d32058","148":"6d93c78b","451":"6d93c78b","493":"019397dd","716":"970a9102","930":"da2159b6","966":"d2d32058"}[chunkId] + ".chunk.css";
};